import React from "react";
import PropTypes from "prop-types";

import { Paragraph } from "components/core/Typography";
import { FacilityPageSection } from "components/facility/FacilityPageSection";

const DescriptionSection = ({ description }) => {
	if (!description) return null;
	return (
		<FacilityPageSection
			title="Description"
			isCollapsable
		>
			<Paragraph size="small">{description}</Paragraph>
		</FacilityPageSection>
	)
};

DescriptionSection.propTypes = {
	description: PropTypes.string
};

export default DescriptionSection;
